import { History } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";
import { fmtTL } from "../../lib/format";

const when = (iso) => (iso ? new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
const how = (h) => (h.increase_pct ? `%${String(h.increase_pct).replace(".", ",")} artış` : h.source === "bulk" ? "toplu · yeni fiyat" : "düzenleme");

// ATM silim fiyatı geçmişi: fiyat hücresindeki saat ikonuna tıklayınca eski → yeni fiyat, tarih ve değiştiren listelenir
export default function AtmPriceHistory({ atm }) {
  const items = atm.price_history || [];
  if (!items.length) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" title={`Fiyat geçmişi (${items.length} değişiklik) — son: ${fmtTL(items[0].old)} → ${fmtTL(items[0].new)}`} className="ml-1 inline-flex items-center justify-center w-5 h-5 rounded text-violet-700 hover:bg-violet-100 align-middle" data-testid={`atm-price-history-${atm.id}`}>
          <History className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0 overflow-hidden" data-testid={`atm-price-history-pop-${atm.id}`}>
        <div className="px-3 py-2 bg-violet-50 border-b border-violet-200 text-[11px] font-bold text-violet-900 uppercase tracking-wider">Silim Fiyatı Geçmişi · {atm.branch_code}</div>
        <ul className="max-h-72 overflow-y-auto divide-y divide-slate-100 text-xs">
          {items.map((h, i) => (
            <li key={i} className="px-3 py-2 flex items-start gap-3" data-testid={`atm-price-history-item-${atm.id}-${i}`}>
              <div className="min-w-0 flex-1">
                <div className="font-mono font-bold text-slate-900"><span className="text-slate-500 line-through font-normal">{fmtTL(h.old)}</span> → {fmtTL(h.new)}</div>
                <div className="text-[11px] text-slate-500 truncate" title={h.set_by}>{when(h.set_at)} · {h.set_by_name || h.set_by}</div>
              </div>
              <span className={`shrink-0 px-1.5 py-0.5 rounded text-[10px] font-bold ${h.new > h.old ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{how(h)}</span>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
